import {Component, OnInit} from '@angular/core';
import {AppComponent} from '../../app.component';
import {Planos} from '../../core/viewModel/planos.model';
import {CategoriaPlanoService} from '../../core/services/categoria_plano.service';

@Component({
  selector: 'app-planos',
  templateUrl: './planos.component.html',
  styleUrls: ['./planos.component.sass']
})
export class PlanosComponent implements OnInit {
  planos: Planos[] = [];
  planos1: Planos[] = [];
  planos1Size = 0;
  planos2: Planos[] = [];
  planos2Size = 0;

  constructor(
      private categoriaPlanoRepository: CategoriaPlanoService,
      private appComponent: AppComponent,
  ) { }

  ngOnInit() {
    this.buscarPlanos();
  }

  async buscarPlanos() {
    this.appComponent.showOverlay();
    this.planos = await this.categoriaPlanoRepository.getListPlanosHome();
    this.separetePlanos();
    this.appComponent.hideOverlay();
  }

  private separetePlanos() {
    const size = this.planos.length;
    if (size > 0) {
      if (this.isPar(size)) {
        this.planos1 = this.planos.slice(0, size / 2);
        this.planos2 = this.planos.slice(size / 2);
      } else {
        this.planos1 = this.planos.slice(0, 4);
        this.planos2 = this.planos.slice(4);
      }
      this.planos1Size = this.planos1.length;
      this.planos2Size = this.planos2.length;
    }
  }

  private isPar(length: number) {
    return (length / 2 === 0);
  }

  isSize(planos1Size: number) {
    return 6;
  }
}
